import React, { useEffect, useState } from "react";
import ContentHeading from "../../../../components/layout/content/ContentHeading";
import InputTextField from "../../../../components/input/inputTextField";
import TableCustom from "../../../../components/table/tableCustom";
import TableRowCommon from "../../../../components/table/TableRowCommon";
import { useDispatch } from "react-redux";
import {
  NavigateFunction,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import { RemoveRedEyeOutlined, SearchOutlined } from "@mui/icons-material";
import { debouncedApiCall } from "../../../../utils/app.utils";
import FilterSelect from "../../../../components/select/filterSelect";
import { Box, Button, MenuItem, Typography } from "@mui/material";
import { routeName } from "../../../../routes/routeName";
import { facultyApi } from "../../../../api/factulty/factulty.api";
import { degreeApi } from "../../../../api/degree/degree.api";
import { advisorEstimateScoreApi } from "../../../../api/advisor-estimate-score/advisor-estimate.api";
import NavigateListCustom from "../../../../components/navigation/NavigationListCustom";
import { colors } from "../../../../constants/colors";
import { ButtonOutlined } from "../../../../components/button/ButtonCustoms";
import { ReportApi } from "../../../../api/report/Report.api";
import {
  setLoading,
  unsetLoading,
} from "../../../../store/loading/loading.slice";
import { getFileExtension } from "../../../../utils/fileTypeDownload";
import { saveAs } from "file-saver";
import { icons } from "../../../../assets/icons/icons";

type Props = {};

const TeacherEvaluationScoresEstimate: React.FC<Props> = (props: Props) => {
  const navigate: NavigateFunction = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const prop_year = queryParams.get("year");
  const prop_term = queryParams.get("term");
  const prop_employee_name = queryParams.get("employee_name");
  const prop_employee_no = queryParams.get("employee_no");
  const prop_id_employee = queryParams.get("id_employee");
  const prop_course = queryParams.get("course");
  const prop_id_course_of_study = queryParams.get("id_course_of_study");
  const prop_id_course_annual = queryParams.get("id_course_annual");

  const [data, setData] = useState<any[]>([]);
  const [dataDetail, setDataDetail] = useState<any>({});

  const [search, setSearch] = useState<string>("");

  const [page, setPage] = useState<number>(1);
  const [pageLimit, setPageLimit] = useState<number>(10);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [sortBy, setSortBy] = useState<string>("");
  const [sortType, setSortType] = useState<string>("ASC");
  const handleRequestSort = (sortBy: string, sortType: string) => {
    setSortBy(sortBy);
    setSortType(sortType);
  };

  const getData = async (id: number) => {
    let query: any = {
      page: page,
      limit: pageLimit,
      sortBy: sortBy,
      sortType: sortType,
      keyword: search ?? "",
    };

    const res =
      await advisorEstimateScoreApi.getCourseStudentEstimateByIdCouresAnnual(
        +id,
        query
      );
    const data = res.data;
    if (data.status < 300) {
      setDataDetail(res.data?.data?.course ?? []);
      setData(res.data?.data?.student?.items ?? []);
      setTotalItems(res.data?.data?.student?.meta?.totalItems || 0);
    } else {
      setData([]);
    }
  };

  const headCells = [
    {
      id: "period",
      width: 150,
      sortable: false,
      disablePadding: false,
      align: "start",
      label: "ชื่อ - นามสกุล",
    },
    {
      id: "period",
      width: 125,
      sortable: false,
      disablePadding: false,
      align: "start",
      label: "ฉายา",
    },
    {
      id: "level",
      width: 100,
      sortable: false,
      disablePadding: false,
      align: "start",
      label: "คะแนนเฉลี่ย",
    },
    {
      id: "action",
      width: 50,
      sortable: false,
      disablePadding: false,
      align: "start",
      label: "",
    },
  ];

  // study_day 0 === อาทิด
  const renderData = (objData: any, no: any) => {
    no = page * pageLimit - pageLimit + no + 1;
    const { ae_id_advisor_estimate, full_name, buddhist_name, points } =
      objData;

    const objRenderData = {
      key: ae_id_advisor_estimate,
      id: no,
      obj: objData,
      columns: [
        {
          option: "TEXT",
          align: "start",
          label: full_name ?? "-",
        },
        {
          option: "TEXT",
          align: "start",
          label: buddhist_name ?? "-",
        },
        {
          option: "TEXT",
          align: "start",
          label: parseFloat(points).toFixed(1) ?? "0",
        },
        {
          option: "TEXT",
          align: "center",
          label: (
            <>
              <RemoveRedEyeOutlined
                onClick={() => {
                  navigate(
                    routeName.advisor.TeacherEvaluationScores +
                      `/${ae_id_advisor_estimate}/course-annual-student-estimate-detail?employee_no=${prop_employee_no}&employee_name=${prop_employee_name}&year=${prop_year}&term=${prop_term}&id_employee=${prop_id_employee}&id_course_of_study=${prop_id_course_of_study}&course=${prop_course}&student_name=${
                        full_name + " " + buddhist_name
                      }&id_course_annual=${prop_id_course_annual}`
                  );
                }}
                style={{
                  cursor: "pointer",
                }}
              />
            </>
          ),
        },
      ],
    };
    return <TableRowCommon {...objRenderData} />;
  };

  useEffect(() => {
    if (id) {
      getData(+id);
    }
  }, [page, pageLimit, sortBy, sortType, search, id]);

  const handleDownloadFile = async (id_annual: number, type: string) => {
    let query: any = {
      type: type,
    };

    dispatch(setLoading());
    await ReportApi.downloadCourseStudentEstimate(id_annual, query)
      .then((res) => {
        if (res.status < 300) {
          const response = res.data;

          const contentType = res.headers["content-type"];

          const blob = new Blob([response], { type: contentType });

          const fileExtension = getFileExtension(contentType || "");

          const fileName = `${new Date().getTime()}.${fileExtension}`;

          saveAs(blob, fileName);
        }
      })
      .catch((error) => console.log(error))
      .finally(() => dispatch(unsetLoading()));
  };

  return (
    <div>
      <NavigateListCustom
        navigateData={[
          {
            name: `คะแนนประเมินอาจารย์ผู้สอน`,
            key: "1",
            pathName: routeName.advisor.TeacherEvaluationScores,
            onClick: () =>
              navigate(`${routeName.advisor.TeacherEvaluationScores}`),
          },
          {
            name: `คะแนนประเมินอาจารย์ผู้สอน ปีการศึกษา ${prop_year} ภาคเรียนที่ ${prop_term}`,
            key: "2",
            pathName: routeName.advisor.TeacherEvaluationScores,
            onClick: () =>
              navigate(
                `${routeName.advisor.TeacherEvaluationScores}/${prop_id_course_of_study}/detail?year=${prop_year}&term=${prop_term}`
              ),
          },
          {
            name: `${prop_employee_name} ${prop_employee_no}`,
            key: "3",
            pathName: "",
            onClick: () =>
              navigate(
                routeName.advisor.TeacherEvaluationScores +
                  `/${prop_id_course_of_study}/course-detail/${prop_id_employee}/employee?employee_no=${prop_employee_no}&employee_name=${prop_employee_name}&year=${prop_year}&term=${prop_term}&id_course_of_study=${prop_id_course_of_study}&course=${prop_course}`
              ),
          },
          {
            name: `${prop_course}`,
            key: "4",
            pathName: "",
          },
        ]}
      />

      {/* header */}
      <section className="my-4">
        <Typography variant="h3">{`${prop_course}`}</Typography>
      </section>

      {/*  */}
      <section className="my-4 mt-4">
        <Box textAlign="center">
          <Typography variant="h6">คะแนนเฉลี่ย</Typography>

          <Typography
            variant="h1"
            fontWeight="bold"
            sx={{
              color: colors.orange,
            }}
          >
            {parseFloat(dataDetail.points).toFixed(1)}
          </Typography>

          <Typography variant="h6">
            ชั้นปีที่สอน : {dataDetail.academic_year}
          </Typography>
        </Box>
      </section>

      <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
        <article className="w-full col-span-12 lg:col-span-3  md:col-span-3  sm:col-span-3">
          <InputTextField
            startAdornment={<SearchOutlined />}
            placeholder="ค้นหาชื่อ - นามสกุล/ชื่อฉายา"
            onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
              debouncedApiCall({
                searchItem: e.target.value,
                setItem: setSearch,
              })
            }
          />
        </article>

        <article className="w-full col-span-12 lg:col-span-9 md:col-span-9 sm:col-span-9 flex justify-end">
          <Button
            variant="outlined"
            sx={{
              backgroundColor: colors.danger,
              color: "white",
              border: colors.danger,
              margin: "0px 4px",
              "&:hover": {
                backgroundColor: colors.danger, // Retain the same background color
                borderColor: colors.danger, // Retain the same border color
              },
            }}
            startIcon={<img src={icons.icon_pdf} alt="start-icon" />}
            onClick={() => {
              if (id) {
                handleDownloadFile(+id, "pdf");
              }
            }}
          >
            ดาวน์โหลด PDF
          </Button>

          <Button
            variant="outlined"
            sx={{
              backgroundColor: colors.success3,
              color: "white",
              border: colors.success3,
              "&:hover": {
                backgroundColor: colors.success3, // Retain the same background color
                borderColor: colors.success3, // Retain the same border color
              },
            }}
            startIcon={<img src={icons.icon_excel} alt="start-icon" />}
            onClick={() => {
              if (id) {
                handleDownloadFile(+id, "xlsx");
              }
            }}
          >
            ดาวน์โหลด Excel
          </Button>
        </article>
      </div>

      <section className="w-full mt-10">
        <TableCustom
          tableMinWidth={1440}
          tableFixedWidth
          customScroll
          page={page}
          pageLimit={pageLimit}
          sortBy={sortBy}
          sortType={sortType}
          headCells={headCells}
          rowCount={totalItems}
          rowsData={
            data &&
            data.map((data: any, i: any) => {
              return renderData(data, i);
            })
          }
          onSort={handleRequestSort}
          setPageLimit={(value: number) => setPageLimit(value)}
          setPage={(value: number) => setPage(value)}
        />
      </section>

      <div
        style={{
          display: "flex",
          gap: "10px",
          justifyContent: "center",
          marginTop: "20px",
        }}
      >
        <ButtonOutlined
          onClick={() => navigate(-1)}
          mode="del"
          buttonName="ย้อนกลับ"
        />
      </div>
    </div>
  );
};

export default TeacherEvaluationScoresEstimate;
